
const ServiceHero = () => {
  return (
    <section className="relative pt-32 pb-24 bg-primary-navy overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/b65019863ae26ecb2484c493fab7e265.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-primary-navy/60"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="text-sm text-gray-400 mb-4 uppercase tracking-wider">
            <a href="/" className="hover:text-white transition-colors whitespace-nowrap cursor-pointer">
              Home
            </a>
            <span className="mx-2">&gt;</span>
            <span className="text-white">Services</span>
          </div>
          <h1 className="font-heading text-5xl lg:text-6xl text-white font-bold mb-6">
            Comprehensive Logistics Solutions
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            From ocean to air, road to rail - we provide end-to-end logistics services tailored to your business needs across all transport modes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
